export default __webpack_public_path__ + "static/media/caret-up.5fd750a4.svg";